import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import DirecteurDetail from './directeur-detail';
import Directeur from './directeur';
import DirecteurDeleteModal from './directeur-delete-modal';
import DirecteurUpdate from './directeur-update';
import PasswordResetInit from 'app/modules/account/password-reset/init/password-reset-init';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/new`} component={DirecteurUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/edit`} component={DirecteurUpdate} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/details`} component={DirecteurDetail} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid`} component={Directeur} />
    </Switch>
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/delete`} component={DirecteurDeleteModal} />
    <ErrorBoundaryRoute path="/account/reset/request" component={PasswordResetInit} />
  </>
);

export default Routes;
